import constants from "./CONSTANTS";

export const initState = {
  user: null,
  login: "",
  session: "",
  regSession: "",
  resPassSession: "",
  loggedIn: false,
  error: "",
  loginAttempts: 0,
  loading: false,
  userMustChangePassword: false,
  ExpirationStatuses: []
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case constants.SET_LOADING:
      return {
        ...state,
        loading: action.loadingState,
      };
    case constants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        error: "",
        loading: false
      };
    case constants.LOGIN_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case constants.LOGOUT_USER:
      return { ...initState };
    case constants.USER_MUST_CHANGE_PASSWORD:
      return {
        ...state,
        userMustChangePassword: action.mustChangePassword
      };
    case constants.SET_APPROVAL_EXPIRATION_STATUS:
      return {
        ...state,
        ExpirationStatuses: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
